var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.167 8.483a.84.84 0 0 0-.59.242.83.83 0 0 0-.244.585v4.552a.413.413 0 0 1-.416.414H4.083a.42.42 0 0 1-.416-.414V6.828c0-.22-.088-.43-.244-.586A.836.836 0 0 0 2 6.828v10.344c0 .22.088.43.244.586a.836.836 0 0 0 1.423-.586v-.827a.41.41 0 0 1 .416-.414h15.834a.42.42 0 0 1 .416.414v.827c0 .22.088.43.244.586a.836.836 0 0 0 1.179 0 .83.83 0 0 0 .244-.586V9.31c0-.22-.088-.43-.244-.585a.84.84 0 0 0-.59-.242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.692 11.586c0 .44.175.86.488 1.17a1.673 1.673 0 0 0 2.357 0 1.65 1.65 0 0 0 0-2.34 1.673 1.673 0 0 0-2.357 0 1.65 1.65 0 0 0-.488 1.17M8.758 12.935a.206.206 0 0 0 .209.207h9.775a.21.21 0 0 0 .208-.232 3.2 3.2 0 0 0-1.049-2.048 3.24 3.24 0 0 0-2.16-.823h-5.408a1.58 1.58 0 0 0-1.11.45 1.56 1.56 0 0 0-.465 1.097z"
  })));
};
export default SvgBed;